export function currencyFilter(amount: number = 0, currency: string = '€') {
  return amount.toFixed(2).replace('.', ',') + currency
}
